import { mapOffersState } from "../../../../utils/mapOfferStates";

export const getStateLabel = (stateNumber) => {
    if (stateNumber === null || stateNumber === undefined) return "N/A";
    const result = mapOffersState([{ status: stateNumber }]);
    return result[0]?.status_label || "N/A";
};